import React from 'react';

import { Box } from 'app/shopify/theme';
import { Column } from 'app/shopify/components/layout';

import { Toast } from './Toast';

export function ToastShowcase() {
  return (
    <Column gap="spacing.general.x3" padding="spacing.general.x4">
      <Toast label="Toast label" validation="Neutral" leadingIcon actions dismissButton breakpoint="Desktop/Tablet" />
      <Toast label="Toast label" validation="Success" leadingIcon actions dismissButton breakpoint="Desktop/Tablet" />
      <Toast label="Toast label" validation="Warning" leadingIcon actions dismissButton breakpoint="Desktop/Tablet" />
      <Toast label="Toast label" validation="Error" leadingIcon actions dismissButton breakpoint="Desktop/Tablet" />

      <Box height={16} />

      <Toast label="Toast label" validation="Neutral" leadingIcon actions dismissButton breakpoint="Mobile" />
    </Column>
  );
}
